import { createSlice } from '@reduxjs/toolkit';
import request from '../../service';
import Exported from '../../service/endpoints';
import config from '../../service/env';

// API service functions for livelihood training
export const createLivelihoodTraining = (data) => {
  // Debug: Log the request details
  console.log('Creating livelihood training:', {
    url: config.livelihoodServiceApi + Exported.Endpoints.livelihoodTrainings,
    data,
    token: localStorage.getItem('accessToken') ? 'Token present' : 'No token',
  });

  return request({
    url: Exported.Endpoints.livelihoodTrainings,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
    },
  });
};

export const getLivelihoodTrainingList = (data) => {
  return request({
    url: Exported.Endpoints.livelihoodTrainings,
    method: Exported.APIMethods.GET,
    params: data === undefined ? undefined : data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodTrainingById = (id) => {
  return request({
    url: `${Exported.Endpoints.livelihoodTrainings}/${id}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateLivelihoodTraining = (data, id) => {
  return request({
    url: `${Exported.Endpoints.livelihoodTrainings}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const deleteLivelihoodTraining = (id) => {
  return request({
    url: `${Exported.Endpoints.livelihoodTrainings}/${id}`,
    method: Exported.APIMethods.DELETE,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Lesson API functions
export const createLivelihoodLesson = (data) => {
  return request({
    url: Exported.Endpoints.lessonModule,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodLessonList = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.lessonModule}/${id}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getEventLiModuleDropdown = () => {
  return request({
    url: Exported.Endpoints.getEventLiModuleDropdown,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodLessonById = (id, queryParams) => {
  return request({
    url: `${Exported.Endpoints.getLessonById}/${id}${buildQueryString(queryParams)}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateLivelihoodLesson = (data, id) => {
  return request({
    url: `${Exported.Endpoints.lessonModule}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const deleteLILessonModule = (data) => {
  return request({
    url: `${Exported.Endpoints.lessonModule}/${data?.id}`,
    method: Exported.APIMethods.DELETE,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

const buildQueryString = (params) =>
  params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';

// Get lesson by ID with trainingId query parameter
export const getLivelihoodLessonByIdWithTraining = (id, queryParams) =>
  getLivelihoodLessonById(id, queryParams);

export const getLIEventRegisterApprovalList = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodEventRegisterApproval + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLITrainingApprovalList = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodTrainingApproval + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateTrainingApproval = (data) => {
  return request({
    url: Exported.Endpoints.livelihoodEventRegisterApproval,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateTrainingCompletionApproval = (data) => {
  return request({
    url: Exported.Endpoints.livelihoodTrainingApproval,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLIReportsList = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodReportList + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const exportLivelihoodReport = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodReportExport + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};
export const exportEventLivelihoodReport = (data) => {
  const reportType = data?.reportType || data?.pageToDownload;
  const fileType = 'excel';
  const eventId = data?.eventId;

  const queryParams = new URLSearchParams();
  if (reportType) queryParams.append('reportType', reportType);
  if (fileType) queryParams.append('fileType', fileType);
  if (eventId) queryParams.append('eventId', eventId);

  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

  return request({
    url: Exported.Endpoints.livelihoodReportExport + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};
//Program APIs
export const getFarmerListForProgram = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodFarmerProgram + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const listApprovals = (params) => {
  // params can be a pre-built query string (from URLSearchParams.toString()) or a plain object
  const queryString =
    typeof params === 'string'
      ? params
        ? `?${params}`
        : ''
      : params && Object.keys(params).length
        ? `?${new URLSearchParams(params).toString()}`
        : '';
  return request({
    url: Exported.Endpoints.listApprovals + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const rissGroupDropdownList = (params) => {
  return request({
    url: Exported.Endpoints.rissGroupDropdown,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const programStatusUpdateLI = (farmId, programId, params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.listProgramUpdate + `/${farmId}/${programId}` + queryString,
    method: Exported.APIMethods.PATCH,
    baseUrl: config.livelihoodServiceApi,
    data: params,
  });
};

export const getAllProgramList = () => {
  return request({
    url: Exported.Endpoints.livelihoodProgram,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getAllProgramListNewForID = (id) => {
  return request({
    url: Exported.Endpoints.listProgramsGetNewByID + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmersForProgramApproval = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.liProgramApprovalnew + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getApprovalCyclesNew = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.cyclesLIapproval + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateProgramApproval = (data) => {
  return request({
    url: Exported.Endpoints.livelihoodProgramApproval,
    method: Exported.APIMethods.PATCH,
    baseUrl: config.livelihoodServiceApi,
    data,
  });
};

export const updateProgramForFarmer = (id, data) => {
  return request({
    url: Exported.Endpoints.programsPatchByIDNew + id,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmersByProgram = (programId, params) => {
  const queryString =
    params && Object.keys(params)?.length
      ? `?${new URLSearchParams(params).toString()}`
      : `?order=ASC&page=1&take=10&programId=${programId}`;
  return request({
    url: Exported.Endpoints.livelihoodFarmerProgram + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Farmer Journeys API
export const getFarmerJourneys = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.farmerJourneys + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Farmer Event List API (ongoing / completed)
export const getFarmerEventList = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.farmerEventList + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Export Farmer Journeys API
export const exportFarmerJourneys = (params) => {
  return request({
    url: Exported.Endpoints.farmerJourneysExport,
    method: Exported.APIMethods.POST,
    data: params,
    baseUrl: config.livelihoodServiceApi,
    responseType: 'blob',
    sendRes: true,
  });
};

// Data Collection APIs
export const getDataCollectionCC = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.getAllDataCollection}/groups${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmersListByGroup = (groupId) => {
  return request({
    url: `${Exported.Endpoints.getAllDataCollection}/groups/${groupId}/farmers`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodFarmerParticipant = (farmerId) => {
  return request({
    url: Exported.Endpoints.livelihoodFarmerParticipantById + farmerId,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodModuleDropdown = () => {
  return request({
    url: Exported.Endpoints.livelihoodTrainingModulesDropdown,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodFarmerDocuments = (farmerId) => {
  return request({
    url: Exported.Endpoints.livelihoodFarmerDocuments + farmerId,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodFarmerForms = (farmerId, rissGroupId) => {
  return request({
    url: `/data-collection/farmers/${farmerId}/${rissGroupId}/forms`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLivelihoodGroups = (page = 1, search = '', take = 10) => {
  return request({
    url: `/data-collection/groups?page=${page}&take=${take}&orderByValue=groupName&search=${encodeURIComponent(
      search
    )}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const postLivelihoodFarmerDocuments = (farmerId, data) => {
  return request({
    url: Exported.Endpoints.uploadfile,
    method: Exported.APIMethods.POST,
    baseUrl: config.documentServiceApi,
    data,
  });
};

// Events
export const getLIEventByID = (id) => {
  return request({
    url: `${Exported.Endpoints.livelihoodEvent}/${id}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const createLIEventSubmit = (data) => {
  return request({
    url: Exported.Endpoints.livelihoodCreateEvent,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const patchLIEventByID = (id, data) => {
  return request({
    url: `${Exported.Endpoints.livelihoodEvent}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLIEventsList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodEvent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getCalendarLIEventList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getCalendarEvent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getInviteParticipantLI = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.inviteLIevent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const postLIInviteParticipant = (data) => {
  return request({
    url: Exported.Endpoints.postLIInvite,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getEventParticipantInvite = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getEventParticipantInvite + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getParticipantList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodParticipants + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLiAttendanceByEventId = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.attendanceByLiEventID + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const fetchLIForms = (data) => {
  return request({
    url: `${Exported.Endpoints.fetchLIForms + data.farmerId}/${data.rissGroupId}/forms`,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const markLIAttendanceByparticipant = (data) => {
  return request({
    url: Exported.Endpoints.markLIAttendance,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getTrunkSampling = (farmId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitTrunkSampling}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitTrunkSampling = (data) => {
  return request({
    url: Exported.Endpoints.submitTrunkSampling,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getSoilSampling = (farmId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitSoilSampling}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitSoilSampling = (data) => {
  return request({
    url: Exported.Endpoints.submitSoilSampling,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getTrunkAnalysis = (formId, queryParams = {}) => {
  const qParams = { ...queryParams, type: 'trunk_analysis' };
  const queryString = `?${new URLSearchParams(qParams).toString()}`;
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFormsNew}${formId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitTrunkAnalysis = (data) => {
  return request({
    url: Exported.Endpoints.submitTrunkAnalysis,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Plant Analysis Functions
export const getPlantAnalysis = (farmId, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.submitPlantAnalysis}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitPlantAnalysis = (data) => {
  return request({
    url: Exported.Endpoints.submitPlantAnalysis,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Soil Verification Functions
export const getSoilVerification = (farmId, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFormsNew}${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitSoilVerification = (data) => {
  return request({
    url: Exported.Endpoints.submitSoilVerification,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Fertilizer Recommendation APIs
export const getFertilizerRecommendation = (farmId, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFormsNew}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitFertilizerRecommendation = (data) => {
  return request({
    url: Exported.Endpoints.submitFertilizerRecommendation,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Fertilizer Received APIs
export const getFertilizerReceived = (farmId, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.submitFertilizerReceived}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitFertilizerReceived = (data) => {
  return request({
    url: Exported.Endpoints.submitFertilizerReceived,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getGanodermaCensus = (farmId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitGanodermaCensus}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitGanodermaCensus = (data) => {
  return request({
    url: Exported.Endpoints.submitGanodermaCensus,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getSoilAnalysis = (formId, queryParams = {}) => {
  const qParams = { ...queryParams, type: 'soil_analysis' };
  const queryString = `?${new URLSearchParams(qParams).toString()}`;
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFormsNew}${formId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

//done by selva dont touch
export const getDataCollectionALLData = (formId, queryParams = {}) => {
  if (queryParams?.type === 'gap_audit') {
    return request({
      url: `${Exported.Endpoints.submitGapAudit}/${formId}`,
      method: Exported.APIMethods.GET,
      baseUrl: config.livelihoodServiceApi,
    });
  }

  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFormsNew}${formId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const deleteSamplingPoint = (id, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.deleteSamplingPoint}${id}${queryString}`,
    method: Exported.APIMethods.DELETE,
    baseUrl: config.livelihoodServiceApi,
    data: queryParams,
  });
};

export const getDataCollectionFipTrafficLight = (farmId, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFipTrafficLight}${farmId}/populate${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getDataCollectionFipTrafficLightDownload = (farmId, queryParams = {}) => {
  const queryString = Object.keys(queryParams).length
    ? `?${new URLSearchParams(queryParams).toString()}`
    : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFipTrafficLight}${farmId}/download${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    responseType: 'blob',
  });
};

export const getDataCollectionALLDataImages = () => {
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionImages}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

//done by selva dont touch
export const submitDataCollectionPatchNew = (formType, data) => {
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionFormsNewPatcH}${formType}`,
    method: Exported.APIMethods.PATCH,
    baseUrl: config.livelihoodServiceApi,
    data,
  });
};

export const submitSoilAnalysis = (data) => {
  return request({
    url: Exported.Endpoints.submitSoilAnalysis,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getVgm = (farmerId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitVgm}/${farmerId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitVgm = (data) => {
  return request({
    url: Exported.Endpoints.submitVgm,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getGapAudit = (farmId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitGapAudit}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitGapAudit = (data, formRecordId = null) => {
  return request({
    url: formRecordId
      ? `${Exported.Endpoints.submitGapAudit}/${formRecordId}`
      : Exported.Endpoints.submitGapAudit,
    method: formRecordId ? Exported.APIMethods.PATCH : Exported.APIMethods.POST,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmMaintenance = (farmId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitFarmMaintenance}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitFarmMaintenance = (data) => {
  return request({
    url: Exported.Endpoints.submitFarmMaintenance,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const putFormsDataCollectionStatus = (id, data) => {
  return request({
    url: `${Exported.Endpoints.formsPutDataCollectionNewStatus}${id}`,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getGapSamplePoint = (farmId, queryParams = {}) => {
  const queryString =
    queryParams && Object.keys(queryParams)?.length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';
  return request({
    url: `${Exported.Endpoints.submitGapSamplePoint}/${farmId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const submitGapSamplePoint = (data) => {
  return request({
    url: Exported.Endpoints.submitGapSamplePoint,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

// // Data Collection Form APIs
export const fetchDataCollectionForm = (formType, farmId) => {
  let url = null;

  const formTypeMap = {
    'gap-audit': 'gap-audit',
    'farm-maintenance': 'farm_maintenance',
    'gap-audit-sample-points': 'gap_audit_sample_point',
    'gap-sample-point': 'gap-sample-point',
    'ganoderma-census': 'ganoderma-census',
    vgm: 'vgm',
    'plant-analysis': 'plant_analysis',
    'soil-sampling': 'soil-sampling',
    'soil-analysis': 'soil-analysis',
    'soil-verification': 'soil_verification',
    'trunk-sampling': 'trunk-sampling',
    'trunk-analysis': 'trunk-analysis',
  };

  const endpoint = formTypeMap[formType];
  if (endpoint && farmId) {
    url = `/data-collection/${endpoint}/${farmId}`;
  }

  if (!url) {
    return Promise.reject(new Error('Invalid form type or farm ID'));
  }

  return request({
    url,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: 'application/json',
    },
  });
};

export const submitDataCollectionForm = (formType, farmId, formData) => {
  let url = null;

  const formTypeMap = {
    'gap-audit': 'gap-audit',
    'farm-maintenance': 'farm_maintenance',
    'gap-audit-sample-points': 'gap_audit_sample_point',
    'gap-sample-point': 'gap-sample-point',
    'ganoderma-census': 'ganoderma-census',
    vgm: 'vgm',
    'plant-analysis': 'plant-analysis',
    'soil-sampling': 'soil-sampling',
    'soil-analysis': 'soil-analysis',
    'soil-verification': 'soil_verification',
    'trunk-sampling': 'trunk-sampling',
    'trunk-analysis': 'trunk-analysis',
  };

  const endpoint = formTypeMap[formType];
  if (endpoint && farmId) {
    url = `/data-collection/${endpoint}/${farmId}`;
  }

  if (!url) {
    return Promise.reject(new Error('Invalid form type or farm ID'));
  }

  return request({
    url,
    method: Exported.APIMethods.PATCH,
    data: formData,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};

export const getDataCollectionForms = (farmerId, rissGroupId) => {
  console.log('-----------vada c127bd3c-ff56-4906-b953-d5ec0f5c0180', rissGroupId);

  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionForms}/${farmerId}/${rissGroupId}/forms`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: 'application/json',
    },
  });
};

// Get Data Collection Forms (without rissGroupId - farmId as query param)
export const getDataCollectionFormsV2 = (farmerId, farmId) => {
  const queryString = farmId ? `?farmId=${farmId}` : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionForms}/${farmerId}/forms${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: 'application/json',
    },
  });
};

export const getDataCollectionProgress = (farmerId, farmId) => {
  const queryString = farmId ? `?farmId=${farmId}` : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionProgress}/${farmerId}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: 'application/json',
    },
  });
};

export const getFormData = (formType, farmerId) => {
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionForm}/${formType}/${farmerId}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: 'application/json',
    },
  });
};

export const submitFormData = (formType, formData, hasFiles = false) => {
  const headers = {
    accept: '*/*',
  };
  if (!hasFiles) {
    headers['Content-Type'] = 'application/json';
  }

  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionForm}/${formType}`,
    method: 'PATCH',
    baseUrl: config.livelihoodServiceApi,
    data: formData,
    headers,
  });
};

export const getDataCollectionGroups = (page = 1, search = '') => {
  const queryString = new URLSearchParams({
    page,
    take: 10,
    orderByValue: 'groupName',
    search,
  }).toString();

  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionGroups}?${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: {
      accept: '*/*',
    },
  });
};

const fetchGroupParticipants = (groupId, page = 1, take = 10, search = '', program = '') => {
  const programParam = program ? `&program=${encodeURIComponent(program)}` : '';
  return request({
    url: `${Exported.Endpoints.livelihoodDataCollectionGroups}/${groupId}/farmers?page=${page}&take=${take}&search=${encodeURIComponent(search)}${programParam}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
    headers: { accept: '*/*' },
  });
};

export const getDataCollectionGroupParticipants = (
  groupId,
  page = 1,
  take = 10,
  search = '',
  program = ''
) => fetchGroupParticipants(groupId, page, take, search, program);

export const getDataCollectionGroupParticipantsNew = (
  groupId,
  page = 1,
  take = 10,
  search = '',
  program = ''
) => fetchGroupParticipants(groupId, page, take, search, program);

// Mapping
export const getFarmerMappings = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.farmerMappings + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Dashboard
export const getLivelihoodDashboard = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.diffusionDashboard + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

// Assessment APIs
export const getAssessmentGroups = (params) => {
  const queryString =
    params && Object.keys(params)?.length ? `?${new URLSearchParams(params).toString()}` : '';
  return request({
    url: Exported.Endpoints.assessmentGroups + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmersByGroupId = (groupId, params) => {
  let url = `${Exported.Endpoints.assessmentGroupsFarmers}/${groupId}/farmers`;
  if (params && Object.keys(params)?.length) {
    url += `?${new URLSearchParams(params).toString()}`;
  }
  return request({
    url: url,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmerForms = (farmerId, rissGroupId) => {
  let url = `${Exported.Endpoints.assessmentFarmerForms}/${farmerId}/forms`;
  if (rissGroupId) {
    url += `?rissGroupId=${rissGroupId}`;
  }
  return request({
    url,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const upsertFarmerAssessment = (data) => {
  return request({
    url: Exported.Endpoints.farmerAssessment,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFarmerAssessment = (farmerId) => {
  return request({
    url: `${Exported.Endpoints.farmerAssessment}/${farmerId}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const upsertFipTrafficLight = (data) => {
  return request({
    url: Exported.Endpoints.fipTrafficLight,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getFipTrafficLight = (farmId) => {
  return request({
    url: `${Exported.Endpoints.fipTrafficLight}/${farmId}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateAssessmentCycle = (data) => {
  return request({
    url: Exported.Endpoints.assessmentCycle,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const updateAssessmentCycleApproval = (data) => {
  return request({
    url: Exported.Endpoints.cyclesLIapprovalAction,
    method: Exported.APIMethods.PATCH,
    baseUrl: config.livelihoodServiceApi,
    data,
  });
};

export const getProgramParticipantFieldOfficer = () => {
  return request({
    url: Exported.Endpoints.programGroupParticipants,
    method: Exported.APIMethods.get,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getProgramByIDFieldOfficer = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.programGroupByIdParticipants}${id}${queryString}`,
    method: Exported.APIMethods.get,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getDataCollectionByIdFormsList = (id) => {
  return request({
    url: `${Exported.Endpoints.formsGetDataCollectionNew}${id}/forms`,
    method: Exported.APIMethods.get,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getAssessmentlistbyGroupsNew = (id) => {
  return request({
    url: `${Exported.Endpoints.ccAssessmentGroups}`,
    method: Exported.APIMethods.get,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getAssessmentlistbyGroupsParticipantNew = (id) => {
  return request({
    url: `${Exported.Endpoints.ccAssessmentGroupsParticipants}?group_id=${id}`,
    method: Exported.APIMethods.get,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getDataCollectionByIdFormsListNew = (id, rissGroupId, farmID) => {
  const rissGroupIdParam = rissGroupId ? rissGroupId : '';
  // &farmId=${farmID}
  return request({
    url: `${Exported.Endpoints.newDataCollectionGetFarmDetails}${id}/forms?rissGroupId=${rissGroupIdParam}`,
    method: Exported.APIMethods.get,
    baseUrl: config.livelihoodServiceApi,
  });
};

export const getLiCollectionCenter = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.liCollectionCenter}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.livelihoodServiceApi,
  });
};

// // Create the slice
const livelihoodSlice = createSlice({
  name: 'livelihood',
  initialState: {
    trainings: [],
    currentTraining: null,
    lessons: [],
    currentLesson: null,
    isLoading: false,
    error: null,
    isFormDirty: false,
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTrainings: (state, action) => {
      state.trainings = action.payload;
    },
    setCurrentTraining: (state, action) => {
      state.currentTraining = action.payload;
    },
    addTraining: (state, action) => {
      state.trainings.push(action.payload);
    },
    updateTrainingInList: (state, action) => {
      const index = state.trainings.findIndex((training) => training.id === action.payload.id);
      if (index !== -1) {
        state.trainings[index] = action.payload;
      }
    },
    removeTraining: (state, action) => {
      state.trainings = state.trainings.filter((training) => training.id !== action.payload);
    },
    // Lesson actions
    setLessons: (state, action) => {
      state.lessons = action.payload;
    },
    setCurrentLesson: (state, action) => {
      state.currentLesson = action.payload;
    },
    addLesson: (state, action) => {
      state.lessons.push(action.payload);
    },
    updateLessonInList: (state, action) => {
      const index = state.lessons.findIndex((lesson) => lesson.id === action.payload.id);
      if (index !== -1) {
        state.lessons[index] = action.payload;
      }
    },
    removeLesson: (state, action) => {
      state.lessons = state.lessons.filter((lesson) => lesson.id !== action.payload);
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setIsFormDirty: (state, action) => {
      state.isFormDirty = action.payload;
    },
  },
});

export const {
  setLoading,
  setTrainings,
  setCurrentTraining,
  addTraining,
  updateTrainingInList,
  removeTraining,
  setLessons,
  setCurrentLesson,
  addLesson,
  updateLessonInList,
  removeLesson,
  setError,
  clearError,
  setIsFormDirty,
} = livelihoodSlice.actions;

export { livelihoodSlice };
